import { z } from 'zod';
/**
 * LỊCH SỬ TRUY CẬP (25/09/2026): ai đăng nhập lúc nào, và mở những mục nào.
 *
 * Đăng nhập đọc thẳng từ nhật ký `audit_log` (đã ghi sẵn từ đầu, kèm địa chỉ IP). Phần «mở mục
 * nào» đếm theo NGÀY chứ không lưu từng lượt bấm: quản lý cần biết ai dùng mục gì, bao nhiêu, lần
 * cuối khi nào — không cần một cuốn sổ theo dõi từng cú nhấp.
 */
/** Khoảng thời gian xem: 7 ngày, 30 ngày, hoặc toàn bộ. */
export const ACTIVITY_RANGES = ['7', '30', 'all'];
export const activityQuerySchema = z.object({
    range: z.enum(ACTIVITY_RANGES).default('30'),
});
export const trackScreenRequestSchema = z.object({
    /** Đường dẫn màn hình vừa mở; máy chủ tự tra ra mã màn hình, đường dẫn lạ thì bỏ qua. */
    path: z.string().trim().min(1).max(200),
});
//# sourceMappingURL=activity.js.map